import * as React from 'react';
import { ListPage } from '../../../ui';
import { ClaimReviewListFilter, ClaimReviewList } from './index';

class ClaimReviewListPage extends React.PureComponent {
  render() {
    return (
      <ListPage filter={<ClaimReviewListFilter/>}>
        <ClaimReviewList/>
      </ListPage>
    );
  }
}

export default ClaimReviewListPage;
